export default __webpack_public_path__ + "static/media/start-mushroom_EN.68fa40ea.png";